const { useState } = require('react');

export const useFormValues = (initialValues, clearErrorFn) => {
    const [formValues, setFormValues] = useState(initialValues);

    function handleChange(e) {
        if (clearErrorFn) clearErrorFn();

        setFormValues((prev) => ({
            ...prev,
            [e.target.name]: e.target.files ? e.target.files : e.target.value,
        }));
    }

    function clearForm() {
        setFormValues(initialValues);
    }

    return { formValues, handleChange, setFormValues, clearForm };
};
